/*
 * @Author: Teemo Ding
 * @Date: 2021-08-06 15:39:08
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-25 14:07:54
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/CustomerDatabaseSettings/AdvancedCustomerInformation/index.tsx
 */
import React from 'react';
//import { Button } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
//import Table from '@/src/components/Antd/Table/SizeFittingTable';
import ModalHoc from 'src/constrains/ModalHOC';
// import { AdvancedCustomerInformationColumn } from '../config';
// import ErrorModalTitle from '@/src/components/ErrorModal/ErrorModalTitle';
// import ErrorModal from '@/src/components/ErrorModal/ErrorModal';
// import EditAdvancedModal from './EditAdvancedModal';
import Configuration from '@/src/components/Configuration/Configuration';
//import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from '../css.module.less';

const AdvancedCustomerInformation = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  // const {
  //   modalOp: { setShowModal, setModalTitle, setModalContent },
  //   onAddAvailable,
  //   onEditAvailable,
  //   onDeleteAvailable,
  //   available,
  //   disabled,
  // } = props;

  // const onEdit = (record, index) => {
  //   setShowModal(true);
  //   setModalTitle('Edit Advanced Customer Information Field');
  //   setModalContent(
  //     <EditAdvancedModal
  //       setShowModal={setShowModal}
  //       onAddAvailable={(value) => onEditAvailable(value, index)}
  //       defaultData={record}
  //     />,
  //   );
  // };
  // const onDelete = (index, record) => {
  //   setShowModal(true);
  //   setModalTitle(
  //     <ErrorModalTitle>
  //       Delete Advanced Customer Information Field
  //     </ErrorModalTitle>,
  //   );

  //   if (record.inUse) {
  //     setModalContent(
  //       <div>
  //         <p>
  //           This advanced customer information field cannot be deleted as it is
  //           being used.
  //         </p>
  //         <ModalFooter onOk={() => setShowModal(false)} okText='OK' />
  //       </div>,
  //     );
  //   } else {
  //     setModalContent(
  //       <ErrorModal
  //         setModal={setShowModal}
  //         onSubmit={() => onDeleteAvailable(index)}
  //         errorText='Deleted advanced customer information field cannot be recovered. Are you sure to delete this advanced customer information field?'
  //         okText='Delete'
  //       />,
  //     );
  //   }
  // };

  // const addAdvanced = () => {
  //   const availableNameList = available.map((item) => item.name);
  //   setShowModal(true);
  //   setModalTitle('Add Advanced Customer Information Field');
  //   setModalContent(
  //     <EditAdvancedModal
  //       setShowModal={setShowModal}
  //       onAddAvailable={onAddAvailable}
  //       availableNameList={availableNameList}
  //     />,
  //   );
  // };
  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={css.advancedCustomerInformationField}
        title={getI18n(
          'customerDatabaseSetting.advancedCustomerInformation.informationField',
        )}>
        {/* {available.length ? (
          <Table
            pagination={false}
            id='AdvancedCustomerInformationField'
            dataSource={available}
            rowKey='uuid'
            columns={AdvancedCustomerInformationColumn(
              onDelete,
              onEdit,
              disabled,
            )}
          />
        ) : (
          <p>No advanced customer information field</p>
        )}
        <div className={css.addBtn}>
          <Button type='primary' onClick={addAdvanced} disabled={disabled}>
            Add Customer Information Field
          </Button>
        </div> */}
        <Configuration
          configStart={getI18n(
            'customerDatabaseSetting.advancedCustomerInformation.configStart',
          )}
          configLink={''}
          configEnd={getI18n(
            'customerDatabaseSetting.advancedCustomerInformation.configEnd',
          )}
          hideGt
        />
      </SectionWrapper>
    </div>
  );
};

export default ModalHoc(AdvancedCustomerInformation);
